import React, { useState, useEffect } from 'react'
import { List, ListItem, ListItemText, Divider, IconButton } from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';
import InfoIcon from '@material-ui/icons/Info';
import ToggleButton from '@material-ui/lab/ToggleButton';
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup';
import ListEditor from './ListEditor';
import localStorageService from '../../services/LocalStorageService';
import { useStore } from '../../Store'

const ObservationList = ({ formik }) => {
  const { plots, settings, createObservation, shortlist } = useStore()
  const [abundance, setAbundance] = useState({})
  const [sci, ] = useState(localStorageService.getItem('SCI'))
  const [open, setOpen] = useState(false)
  const [group, setGroup] = useState({ group: 'n/a', members: [] })

  const plot = plots.find(p => p.id === formik.values.plot)
  const taxaList = settings.taxaLists.find(t => t.id === plot.taxaListId)

  const closeEditor = () => {
    setOpen(false)
  }

  const openEditor = (taxaGroup) => {
    setGroup(taxaGroup)
    setOpen(true)
  }

  const initialValues = () => {
    const values = {}
    formik.values.observations.forEach(o => {
      values[o.taxLisTaxId] = o.abundance
    })
    return values
  }

  const show = (item) => {
    if (item.info.group in shortlist)
      return shortlist[item.info.group].includes(item.id) || item.id in abundance
    if (item.info.shortlist === "1")
      return true
    return item.id in abundance
  }

  useEffect(() => {
    setAbundance(initialValues())
  }, [])

  const getTaxa = () => {
    if (!plot) return []
    if (!taxaList) return []
    return taxaList.taxa.filter(t => t.type === 'row').sort((a, b) => a.sortorder > b.sortorder ? 1 : -1)
  }

  const taxaItems = () => {
    const groups = []
    let group = null
    getTaxa().forEach(item => {
      if (group === null || group.group !== item.info.group) {
        group = { group: item.info.group, show: item.info.group === 'Bijschrijfsoorten' ? false : true, members: [] }
        groups.push(group)
      }
      group.members.push(item)
    });
    // Sorteer de members binnen elke groep op info['sci'] en daarna op info['lifestage_name']
    groups.forEach(g => {
      g.members.sort((a, b) => {
        const nameA = a.info[sci ? 'sci' : 'com'] || '';
        const nameB = b.info[sci ? 'sci' : 'com'] || '';
        if (nameA < nameB) return -1;
        if (nameA > nameB) return 1;
        const lifeA = a.info['lifestage_name'] || '';
        const lifeB = b.info['lifestage_name'] || '';
        if (lifeA < lifeB) return -1;
        if (lifeA > lifeB) return 1;
        return 0;
      });
    });
    return groups;
  }

  const info = (item) => {
    const name = item.info[sci ? 'sci' : 'com']
    let link
    if (item.info['link']) {
      link = <IconButton size="small" href={item.info['link']} target="_blank"><InfoIcon /></IconButton>
    } else {
      link = null
    }
    return <>{name}{link}</>
  }

  const handleAbundance = (items, value) => {
    const newAbundance = { ...abundance }
    const observations = formik.values.observations
    if (value == null) return
    items.forEach((item, index) => {
      newAbundance[item.id] = value
      const observation = observations.find(obs => obs.taxLisTaxId === item.id)
      if (observation) {
        observation.dirty = 1
        // existing item
        if (value === '?') {
          observation.delstaId = 1
        } else {
          observation.delstaId = 0
          observation.abundance = value
        }
      } else {
        const obs = createObservation()
        obs.taxLisTaxId = item.id
        obs.abundance = value
        obs.dirty = 1
        observations.push(obs)
      }
    })
    formik.setFieldValue('observations', observations.filter(obs => obs.id > 0 || obs.delstaId === 0))
    setAbundance(newAbundance)
  }

  return (
    <>
      <List dense={true} component="nav" aria-label="waarnemingen" style={{ marginBottom: '57px' }}>
        {taxaItems().map((g, i) => (
          <>
            <ListItem style={{ backgroundColor: process.env.REACT_APP_SECONDARYCOLOR }} divider >
              <Divider />
              <ListItemText primary={g.group} />
              <IconButton aria-label="delete" onClick={() => openEditor(g)} >
                <EditIcon />
              </IconButton>
              <ToggleButtonGroup
                exclusive
                size='small'
                onChange={() => handleAbundance(g.members.filter(item => show(item)), '0')}
                value='0'
              >
                <ToggleButton disabled value="?">
                  ?
                </ToggleButton>
                <ToggleButton value="0">
                  0
                </ToggleButton >
                <ToggleButton disabled value="Z">
                  Z
                </ToggleButton>
                <ToggleButton disabled value="A">
                  A
                </ToggleButton>
                <ToggleButton disabled value="M">
                  M
                </ToggleButton>
              </ToggleButtonGroup>
            </ListItem>
            {g.members.filter(item => show(item)).map((item) => (
              <ListItem>
                <ListItemText
                  primary={info(item)}
                  secondary={<div>
                    <div><i>{item.info[sci ? 'com' : 'sci']}</i></div>
                    <div><small>{item.info['lifestage_name']}</small></div>
                  </div>} />
                <ToggleButtonGroup value={item.id in abundance ? abundance[item.id] : '?'}
                  exclusive
                  onChange={(event, value) => handleAbundance([item], value)}
                  size='small'
                >
                  <ToggleButton value="?">
                    ?
                  </ToggleButton>
                  <ToggleButton value="0">
                    0
                  </ToggleButton >
                  <ToggleButton value="Z">
                    Z
                  </ToggleButton>
                  <ToggleButton value="A">
                    A
                  </ToggleButton>
                  <ToggleButton value="M">
                    M
                  </ToggleButton>
                </ToggleButtonGroup>
              </ListItem>
            ))}
          </>
        ))
        }
      </List>
      <ListEditor sci={sci} group={group} onClose={closeEditor} info={info} open={open} />
    </>
  )
}

export default ObservationList